const initialPasswordState = {
    passwordMessages: {},
  };
  
  const PasswordReducer = (state = initialPasswordState, action) => {
    switch (action.type) {
      case 'RESET_PASSWORD':
        return {
          ...state,
          passwordMessages: action.payload.data,
        };
  
      case 'FORGET_PASSWORD':
        return {
          ...state,
          passwordMessages: action.payload.data,
        };
  
      default:
        return state;
    }
  };
  
  export default PasswordReducer;
  